// Module
var code = " <section class=\"location-detection\" data-ng-if=\"$ctrl.displayType == 'linkOnly'\"> <div class=\"selector\"> <button class=\"cta\" data-confirm data-analyticsvalue=\"change location - set location\" data-analyticsid=\"Footer-Tools-Location-Update\">{{ 'geolocation.update-location' | translate }}</button> </div> </section> ";
// Exports
export default code;